import AddIcon from '@mui/icons-material/Add'
import { Button, Hidden } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import { useAddLogMutation } from '../../../api/mutations/__generated__/addLog.gql'
import useCurrentUser from '../../../hooks/useCurrentUser'
import useUserPermissions from '../../../hooks/useUserPermissions'
import { useButtonsStyles } from '../../../styles'
import PageContent from '../../Common/pageContent/PageContent'
import PageContentBody from '../../Common/pageContent/PageContentBody'
import PageContentHeader from '../../Common/pageContent/PageContentHeader'
import { CaregiverDataTable } from './CaregiverDataTable'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import { CaregiverListFilters } from './CaregiverListFilters'
import { CaregiverFilters } from './_types'

export const CaregiverList = () => {
    const currentUser = useCurrentUser()
    const currentHcs = useCurrentHcs()
    const { hasUserPermission } = useUserPermissions()
    const buttonsClasses = useButtonsStyles()
    const [filters, setFilters] = React.useState<CaregiverFilters>({
        roles: [],
        positions: [],
    })

    const [sendLog] = useAddLogMutation()

    React.useEffect(() => {
        sendLog({
            variables: {
                input: {
                    hcsId: currentHcs.id,
                    fromApp: 'IDS',
                    userId: currentUser.id,
                    message: `[UserList] Accès liste effecteur`,
                    logLevel: 'INFO',
                },
            },
        })
    }, [filters])

    const onFiltersChange = (newFilters: CaregiverFilters) => {
        setFilters(newFilters)
    }

    return (
        <PageContent>
            <PageContentHeader
                left={<CaregiverListFilters filters={filters} onChange={onFiltersChange} />}
                right={
                    hasUserPermission('ADMIN') && (
                        <Button
                            className={buttonsClasses.ButtonBlack}
                            startIcon={<AddIcon />}
                            component={Link}
                            to="/user"
                            data-cy="caregiverCreationForm"
                        >
                            <Hidden smDown>Ajouter</Hidden>
                        </Button>
                    )
                }
            />
            <PageContentBody>
                <CaregiverDataTable filters={filters} />
            </PageContentBody>
        </PageContent>
    )
}
